import IconDefensaCivil from "../../assets/iconos/info-defensa-civil.svg";
import IconEmergenciaMedica from "../../assets/iconos/info-emergencia-medica.svg";
import IconPolicia from "../../assets/iconos/info-policia.svg";
import IconAtencionVecino from "../../assets/iconos/info-atencion-vecino.svg";
import IconMesaAyuda from "../../assets/iconos/info-mesa-ayuda.svg";
import IconSaludMental from "../../assets/iconos/info-salud-mental.svg";
import IconContactoEmergencia from "../../assets/iconos/info-contacto-emergencia.svg";
import IconNumerosInterno from "../../assets/iconos/info-numeros-interno.svg";
import IconMapaCPC from "../../assets/iconos/info-mapa-cpc.svg";

export const DataInfoUtils: InfoItem[] = [
  {
    id: 1,
    label: "Contacto de Emergencia",
    icon: IconContactoEmergencia,
    actions: [
      {
        action: "navigate",
        path: "/mi-cuenta",
        message: "Debe completar sus datos de contacto de emergencia",
      },
    ],
  },
  {
    id: 2,
    label: "Defensa Civil",
    icon: IconDefensaCivil,
    actions: [{ action: "call", number: "103" }],
    description: "Estás por llamar a Defensa Civil.",
  },
  {
    id: 3,
    label: "Emergencia Médica",
    icon: IconEmergenciaMedica,
    actions: [{ action: "call", number: "107" }],
    description: "Estás por llamar a Emergencia Médica.",
  },
  {
    id: 4,
    label: "Policía",
    icon: IconPolicia,
    actions: [{ action: "call", number: "911" }],
    description: "Estás por llamar a la Policía.",
  },
  {
    id: 5,
    label: "Atención al Vecino",
    icon: IconAtencionVecino,
    actions: [{ action: "call", number: "0800 888 0404" }],
    description: "Estás por llamar a Atención al Vecino.",
  },
  {
    id: 6,
    label: "Mesa de Ayuda",
    icon: IconMesaAyuda,
    actions: [{ action: "whatsapp", number: "+54 9 351 428 5656" }],
    description: "Estás por comunicarte con mesa de ayuda a través de whatsapp",
  },
  {
    id: 7,
    label: "Salud Mental y Adicciones",
    icon: IconSaludMental,
    actions: [{ action: "call", number: "0800 888 5555" }],
    description: "Estás por llamar a Salud Mental y Adicciones.",
  },
  {
    id: 8,
    label: "Números Internos",
    icon: IconNumerosInterno,
    actions: [
      { action: "call", number: "+351 4285600" },
      {
        action: "pdf",
        label: "Lista de contactos",
        url: "https://cordoba.gob.ar/wp-content/uploads/2025/01/Directorio-Interno.pdf",
      },
    ],
    description:
      "Estás por llamar al número interno de la Municipalidad de Córdoba.",
  },
  {
    id: 9,
    label: "Mapa CPC",
    icon: IconMapaCPC,
    actions: [
      {
        action: "url",
        label: "Palacio Municipal y CPCs",
        url: "https://inteligenciaterritorial.cordoba.gob.ar/portal/apps/webappviewer/index.html?id=2373816b419744daafe57f15a0ec9164",
      },
    ],
    description: "Estás por abrir el mapa de CPCs y Palacio Municipal.",
  },
];

export const InfoColors = ["#E1A113", "#971B2F", "#00A0E2"];

export type InfoAction =
  | { action: "call"; number: string }
  | { action: "whatsapp"; number: string }
  | { action: "message"; text: string }
  | { action: "pdf"; label: string; url: string }
  | { action: "url"; label: string; url: string }
  | { action: "navigate"; path: string; message: string }
  | { action: "emergency_alert"; usuario?: any };

export type InfoItem = {
  id: number;
  label: string;
  icon: string;
  actions?: InfoAction[];
  color?: string;
  description?: string;
};
